import { apiClient } from "@copro/api";

// Contract files live in `documents` with the contract's provider_id, so they
// would otherwise show up in the provider's document list/count. This returns
// the document ids owned by the provider's contracts, to exclude them.
export async function fetchContractDocumentIds(providerId: string): Promise<string[]> {
  const { data, error } = await apiClient
    .from('provider_contracts')
    .select('document_id')
    .eq('provider_id', providerId);

  if (error) {
    throw error;
  }

  return (data ?? [])
    .map((contract) => contract.document_id)
    .filter((id): id is string => !!id);
}
